module.exports = __webpack_public_path__ + "img/feature_buy_zh.f191321c.png";